//
//
//
//
//
//
//
//

import FilesGroup from '../../components/File/FilesGroup.js'
import FilesField from '../../components/File/FilesField.vue'

export default {
  name: 'VehicleCardRemarkImages',
  components: {
    FilesField
  },
  props: {
    filesSrc: {
      type: Array,
      default: null
    }
  },
  data: () => {
    return {
      category: null
    }
  },
  watch: {
    filesSrc: {
      handler: function (filesSrc) {
        if (filesSrc) {
          this.category = new FilesGroup({ key: 'document', readonly: true, documents: filesSrc })
        } else {
          this.category = null
        }
      },
      immediate: true
    }
  }
}
